import Command from '@ckeditor/ckeditor5-core/src/command';

export default class SaveCommand extends Command {
  constructor(editor) {
    super(editor);

    this.hasUnsavedChanges = false;
    this.checkDocumentChanges();
    this.refresh();
  }

  execute() {
    this.editor.fire('save');
    this.hasUnsavedChanges = false;
    this.refresh();
  }

  checkDocumentChanges() {
    const doc = this.editor.model.document;
    const undoCommand = this.editor.commands.get('undo');
    undoCommand.on('execute', () => {
      this.hasUnsavedData();
    }, { priority: 'high' });

    const redoCommand = this.editor.commands.get('redo');
    redoCommand.on('execute', () => {
      this.hasUnsavedData();
    }, { priority: 'high' });

    doc.on('change:data', (eventInfo, batch) => {
      // eslint-disable-next-line max-len
      try {
        const isSaveNotReq = localStorage.getItem('createdCommentThreadId');
        const batchOperations = batch.operations[0];
        if (
          !this.editor.isSaveInProgress
          &&
          (batch.isTyping || batch.isUndo || batch.isUndoable)
          && batchOperations.key !== 'data-currentfocused-element' && batchOperations.key !== 'contenteditable'
          && localStorage.getItem('resolveComments') !== 'true') {
          this.hasUnsavedData();
        } else if (isSaveNotReq) {
          localStorage.removeItem('createdCommentThreadId');
          localStorage.removeItem('resolveComments');
        }
      } catch (err) {
        if (!this.editor.isSaveInProgress) {
          this.hasUnsavedData();
        }
      }

      const changesRemoved = eventInfo.source.differ.getChanges();
      if (
        changesRemoved.some(
          (cr) =>
            cr.type === "remove" &&
            (cr.name === "inlineimage" || cr.name === "inlineaudio" || cr.name === "figureTag")
        )
      ) {
        this.editor.fire("removemedia");
      }
    });
  }

  hasUnsavedData() {
    this.hasUnsavedChanges = true;
    this.refresh();
  }

  refresh() {
    this.isEnabled = this.hasUnsavedChanges;
  }
}

